export const filterKeys = {
  name: { key: 'name', description: 'Filter Tradeshow Name' },
  month: { key: 'month', description: 'Month' },
  year: { key: 'year', description: 'Year' },
  startDate: { key: 'startDate', description: 'Start Date' },
  regionCountry: { key: 'regionCountry', description: 'Region / Country' },
  state: { key: 'state', description: 'State / Province' },
  city: { key: 'city', description: 'City' },
  tradeshowStatus: {
    key: 'tradeshowStatus',
    description: 'Tradeshow Status',
  },
  platformStatus: {
    key: 'platformStatus',
    description: 'Platform Status',
  },
  registeredInterest: {
    key: 'registeredInterest',
    description: 'Registered Interest',
  },
  tradeshowEventFormat: {
    key: 'tradeshowEventFormat',
    description: 'Tradeshow Event Format',
  },
  noTbc: {
    key: 'noTbc',
    description: 'Exclude events with unknown location',
  },
  isVirtual: {
    key: 'isVirtual',
    description: 'Include virtual and hybrid events only',
  },
};
